/* eslint-disable import/no-unresolved */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaPhoneAlt } from 'react-icons/fa';
import { Card, Text, Input } from 'v3/components';

import { getPhoneMask } from 'v3/utils/functions';

const EmergencyContact = ({ data, setData, errors }) => {

  const isRequired = data?.name || data?.phone

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Contato de emergência
        </Text>
      }
    >
      <Row >
        <Col lg={6} md={6} xs={12}>
          <Input
            label={`Nome ${isRequired ? '*' : ''}`}
            value={data?.name}
            onChange={({ target }) =>
              setData({
                ...data,
                name: target.value,
              })
            }
            error={errors?.['emergencyContact.name']}
          />
        </Col>
        <Col lg={6} md={6} xs={12}>
          <Input
            icon={<FaPhoneAlt color="#464E5F" />}
            value={data?.phone}
            onChange={({ target }) =>
              setData({
                ...data,
                phone: target.value,
              })
            }
            masked
            mask={getPhoneMask('BR')}
            label={`Telefone ${isRequired ? '*' : ''}`}
            error={errors?.['emergencyContact.phone']}
          />
        </Col>
        <Col lg={6} md={6} xs={12}>
          <Input
            label="Email"
            value={data?.email}
            onChange={({ target }) =>
              setData({
                ...data,
                email: target.value,
              })
            }
          />
        </Col>
      </Row>
    </Card>
  );
};

export default EmergencyContact;
